export const MENU_COLLAPSE_BREAKPOINT = 910;
